import { NavLink, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';

function Header() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    const navLinks = [
        { path: '/', label: 'Home' },
        { path: '/about', label: 'About' },
        { path: '/admission', label: 'Admission' },
        { path: '/programs-and-courses', label: 'Programs' },
        { path: '/gallery', label: 'Gallery' },
        { path: '/contact', label: 'Contact' },
    ];

    return (
        <>
            <div className='bg-[#070E21] text-white text-center px-4 py-2 gap-x-6 hidden sm:flex'>
                <span className='text-sm'><a href="mailto:info@oxfordcollege.lk">info@oxfordcollege.lk</a></span>
                <span className='text-sm'><a href="tel:+94703132302">+94 70 31 32 302</a></span>
                <span className='text-sm'><a href="tel:+94763706240">+94 76 37 06 240</a></span>
            </div>

            <nav className='bg-white text-gray-800 md:px-10 font-poppins z-50 sticky top-0'>
                <div className='flex justify-between items-center relative z-50 bg-white'>
                    <div className='flex items-center cursor-pointer'>
                        <img src='./assets/icons/logo.svg' alt='logo'
                            className='p-2 ms-5 md:ms-0 h-16 md:h-20 aspect-square'
                            onClick={() => window.location.href = '/'} />
                    </div>

                    <ul className='hidden md:flex md:space-x-7 lg:space-x-12'>
                        {navLinks.map((link) => (
                            <NavLink key={link.path} to={link.path}>
                                {({ isActive }) => (
                                    <div className='relative'>
                                        <span>{link.label}</span>
                                        {isActive && (
                                            <div className='absolute w-full h-1 bg-black rounded-full -bottom-2'></div>
                                        )}
                                    </div>
                                )}
                            </NavLink>
                        ))}
                    </ul>

                    <button
                        className='md:hidden p-2 me-5'
                        onClick={() => setIsMenuOpen(!isMenuOpen)}
                    >
                        <svg
                            className="w-6 h-6 transition-transform duration-300"
                            fill="none"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            {isMenuOpen ? (
                                <path d="M6 18L18 6M6 6l12 12" />
                            ) : (
                                <path d="M4 6h16M4 12h16M4 18h16" />
                            )}
                        </svg>
                    </button>
                </div>

                {/* Mobile Navigation Menu */}
                <div
                    className={`md:hidden fixed inset-x-0 bg-white shadow-lg transition-all duration-300 ease-in-out z-40 ${isMenuOpen ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0'
                        }`}
                    style={{
                        top: '50px',
                        height: 'calc(100vh - 50px)'
                    }}
                >
                    <div className='px-4 py-6 space-y-2'>
                        {navLinks.map((link) => (
                            <NavLink
                                key={link.path}
                                to={link.path}
                                className={({ isActive }) =>
                                    `block px-3 py-2 rounded-md text-lg transition-transform duration-300 ease-in-out ${isActive ? 'bg-gray-900 text-white' : 'text-gray-800 hover:bg-gray-100'
                                    }`
                                }
                                onClick={() => setIsMenuOpen(false)}
                            >
                                {link.label}
                            </NavLink>
                        ))}
                    </div>
                </div>
            </nav>
        </>
    );
}

export default Header;